export default __webpack_public_path__ + "static/media/log-out.c4eb0379.svg";